/**
 * Portal (app) + API origins for auth handoff and Stripe checkout.
 * CRA: set REACT_APP_PORTAL_URL / REACT_APP_API_URL in .env
 */
const isProd = process.env.NODE_ENV === 'production';

const defaultPortal = isProd ? 'https://app.section3.ai' : 'http://localhost:3000';
const defaultApi = isProd ? 'https://api.section3.ai' : 'http://127.0.0.1:8000';

function resolvePublicUrl(raw, fallback) {
  const value = (raw || fallback || '').replace(/\/$/, '');
  if (isProd && /^(https?:\/\/)?(localhost|127\.0\.0\.1)(:\d+)?$/i.test(value.replace(/\/$/, ''))) {
    return fallback;
  }
  return value;
}

export const portalOrigin = resolvePublicUrl(process.env.REACT_APP_PORTAL_URL, defaultPortal);
export const apiBase = resolvePublicUrl(process.env.REACT_APP_API_URL, defaultApi);

export const portalUrls = {
  login: `${portalOrigin}/login`,
  signup: `${portalOrigin}/signup`,
  /** Land in the app without bouncing back to a stored marketing ?redirect= */
  dashboard: `${portalOrigin}/?noredirect=1&from=poa_paid`,
  /** After POA payment → Account Connection Session (Calendly), then app workspace */
  bookCall: `${portalOrigin}/book-call?noredirect=1&from=poa_paid`,
};
